/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Retail
 *
 * 1 = Fleet
 *
 * 2 = Motability
 */
export enum CustomerTypeEnum {
  Retail = 0,
  Fleet = 1,
  Motability = 2,
}
